import {
  required,
  email,
  alpha,
  alphaNum,
  minLength,
  maxLength,
  numeric,
  helpers
} from "@vuelidate/validators";

const alphaNum_EN = helpers.regex(/^[a-zA-Z0-9]*$/u);
const customEmailValidator = helpers.regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/u);
const alphaWithSpaces = helpers.regex(/^[A-Za-z\s]+$/);
const numericNoSpaces = helpers.regex(/^[0-9]+(-[0-9]+)*$/);
const alphaSpaceHyphen = helpers.regex(/^[a-zA-Z\s-]+$/);
const alphaNumericWithSpaces = helpers.regex(/^[a-zA-Z0-9\s]+$/);

export default {
  //--------------------------------------------------------------------//
  DEFAULT: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  DRW: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  FM1: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
    privacy_accept: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  FMM: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    //state: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    destination: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
    // privacy_accept: {
    //   required(val) {
    //     return val;
    //   },
    // },
  },
  //--------------------------------------------------------------------//
  GSO: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  ST1: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  HER: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    vehicle_vrn: {
      alphaNum_EN
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  HVN: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  INV: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  IP1: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    //state: { required },
    country: {
      required
    },
    vehicle_vrn: {
      required
    }
  },
  //--------------------------------------------------------------------//
  JER: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    title: {
      required
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    //address: { required },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  LAX: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      alphaWithSpaces,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    //phonecode: { required },
    mobilenumber: {
      //required,
      numeric,
      minLength: helpers.withParams({
          type: 'minLength'
        },
        function (value, vm) {
          const min = vm.phonecode === "+1" ? 10 : 5;
          return value && value.length >= min;
        }
      ),
      maxLength: helpers.withParams({
          type: 'maxLength'
        },
        function (value, vm) {
          const max = vm.phonecode === "+1" ? 10 : 15;
          return value && value.length <= max;
        }
      ),
    },
    //address: { required },
    postcode: {
      required,
      numericNoSpaces,
      minLength: minLength(5),
      maxLength: maxLength(11),
    },
    //town: { required },
    //state: {
    //  required,
    //  alphaWithSpaces,
    //},
    term_condition: {
      required(val) {
        return val;
      },
    },
    privacy_accept: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  LDY: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  ML1: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  NOC: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  NQY: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  NWI: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    state: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  PB1: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {
      required
    },
    //state: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  PIT: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    //vehicle_vrn: { required: requiredIf(this.checkpowerfields) },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  RDU: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  RSW: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      customEmailValidator
    },
    emailid_wo: {
      required,
      customEmailValidator
    },
    phonecode: {
      required
    },
    number_of_passengers: {
      required
    },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    firstname: {
      required,
      minLength: minLength(2)
    },
    surname: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      customEmailValidator
    },
    address: {
      required
    },
    postcode: {
      required
    },
    town: {
      required
    },
    state: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  SV1: {
    password: { required, minLength: minLength(6) },
    emailid: { required, customEmailValidator },
    emailid_wo: { required, customEmailValidator },
    firstname: { required, minLength: minLength(2) },
    surname: { required, minLength: minLength(2) },
    email: { required, customEmailValidator },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: { required },
    postcode: { required },
    town: { required },
    state: { required },
    term_condition: {
      required(val) {
        return val;
      },
    }
  },
  //--------------------------------------------------------------------//
  SZG: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, alpha, minLength: minLength(2) },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    surname: { required, alpha, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    title: { required },
    //state: { required },
    address: { required },
    postcode: { required },
    town: { required },
    country: { required },
    vehicle_vrn: { required },
    term_condition: {
      required(val) {
        return val;
      },
    },
    privacy_accept: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  YHM: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, alpha, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: { required },
    postcode: { required },
    town: { required },
    state: { required },
    vehicle_vrn: { required },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  NUE: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, alpha, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: { required },
    postcode: { required },
    town: { required },
    country: { required },
    vehicle_vrn: { required },
    privacy_accept: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  BFS: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    surname: {
      required,
      alpha,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    // title: {
    //   required
    // },
    state: {},
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    // address: {
    //   required
    // },
    postcode: {
      required
    },
    // town: {
    //   required
    // },
    //country: {},
    vehicle_vrn: {
      required
    },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  BHX: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alphaSpaceHyphen,
      minLength: minLength(2)
    },
    surname: {
      required,
      alphaSpaceHyphen,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {},
    state: {},
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {},
    postcode: {
      required
    },
    town: {},
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    email_consent_selected: { required },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },
  //--------------------------------------------------------------------//
  BH2: {
    password: {
      required,
      minLength: minLength(6)
    },
    emailid: {
      required,
      email
    },
    emailid_wo: {
      required,
      email
    },
    firstname: {
      required,
      alphaSpaceHyphen,
      minLength: minLength(2)
    },
    surname: {
      required,
      alphaSpaceHyphen,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    email_confirm: {
      required,
      email
    },
    phonecode: {
      required
    },
    title: {},
    state: {},
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    address: {},
    postcode: {
      required
    },
    town: {},
    country: {
      required
    },
    vehicle_vrn: {
      required
    },
    email_consent_selected: { required },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },

  //--------------------------------------------------------------------//
  SB2: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    //address: { required },
    postcode: { required, alphaNumericWithSpaces },
    //town: { required },
    country: { required },
    vehicle_vrn: { required, alphaNum },
    // privacy_accept: {
    //   required(val) {
    //     return val;
    //   },
    // },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },

  //--------------------------------------------------------------------//
  SB3: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    //address: { required },
    postcode: { required, alphaNumericWithSpaces },
    //town: { required },
    country: { required },
    vehicle_vrn: { required, alphaNum },
    // privacy_accept: {
    //   required(val) {
    //     return val;
    //   },
    // },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },

  //--------------------------------------------------------------------//
  SB4: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    //address: { required },
    postcode: { required, alphaNumericWithSpaces },
    //town: { required },
    country: { required },
    vehicle_vrn: { required, alphaNum },
    // privacy_accept: {
    //   required(val) {
    //     return val;
    //   },
    // },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },

  //--------------------------------------------------------------------//
  SB5: {
    password: { required, minLength: minLength(6) },
    emailid: { required, email },
    emailid_wo: { required, email },
    firstname: { required, minLength: minLength(2) },
    surname: { required, minLength: minLength(2) },
    email: { required, email },
    email_confirm: { required, email },
    phonecode: { required },
    mobilenumber: {
      required,
      numeric,
      minLength: minLength(7),
      maxLength: maxLength(15),
    },
    //address: { required },
    postcode: { required, alphaNumericWithSpaces },
    //town: { required },
    country: { required },
    vehicle_vrn: { required, alphaNum },
    // privacy_accept: {
    //   required(val) {
    //     return val;
    //   },
    // },
    term_condition: {
      required(val) {
        return val;
      },
    },
  },


  // Add more brands as needed
  //--------------------------------------------------------------------//
};